<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePortalStore } from '@/store/portal'
import AppIcon from '@/components/portal/AppIcon.vue'
import SupportFrame from '@/components/portal/SupportFrame.vue'
// 레거시 메뉴는 외부 ezHelp 원격지원 페이지로 바로 이동했다. 메뉴는 사이트 안 안내 페이지로 두고, 접속은 이 화면의 버튼으로 새 창에서 연다.
const REMOTE_SUPPORT_URL = 'https://939.co.kr/eduinfo/'
const route = useRoute(), portal = usePortalStore()
const title = computed(() => portal.pageOf(route.meta.portalPage)?.title || 'PC원격지원')
const phone = computed(() => portal.footer?.phone || ''), hours = computed(() => portal.footer?.hours || '')
useHead(() => ({ title: `${title.value} · TECHEDU` }))
</script>
<template>
  <SupportFrame :title="title">
    <div class="site-board remote-support">
      <p class="board-description">PC원격지원은 고객님의 지원 요청에 따라 상담원이 직접 고객님의 PC에 접속하여 학습 중 생긴 문제를 해결해 드리는 서비스입니다. 원격지원은 ezHelp PC 원격지원 서비스로 연결됩니다.</p>
      <section class="remote-steps" aria-labelledby="remote-steps-title"><h2 id="remote-steps-title">이용 방법</h2>
        <ol>
          <li><span class="remote-step-no" aria-hidden="true">1</span><div><h3>학습지원센터로 전화해 주세요</h3><p><template v-if="phone">학습지원센터 <strong class="remote-phone">{{ phone }}</strong><template v-if="hours"> · {{ hours }}</template></template><template v-else>학습지원센터로 전화해 원격지원을 요청해 주세요.</template></p></div></li>
          <li><span class="remote-step-no" aria-hidden="true">2</span><div><h3>원격지원 페이지에 접속해 주세요</h3><p>아래 <strong>PC원격지원 접속</strong> 버튼을 누르면 ezHelp 원격지원 페이지가 새 창으로 열립니다.</p></div></li>
          <li><span class="remote-step-no" aria-hidden="true">3</span><div><h3>상담원의 안내에 따라 연결해 주세요</h3><p>상담원 번호 아이콘을 누르거나 접속코드(6자리)를 입력한 뒤 확인 버튼을 누르면 상담원이 PC에 접속합니다.</p></div></li>
        </ol>
      </section>
      <div class="remote-action"><a class="board-btn accent remote-open" :href="REMOTE_SUPPORT_URL" target="_blank" rel="noopener noreferrer"><AppIcon name="monitor" :size="20" />PC원격지원 접속<span class="board-sr-only">(새 창)</span></a></div>
      <ul class="remote-notes">
        <li>원격지원 페이지가 정상적으로 동작하지 않으면 그 페이지의 ‘고객접속 프로그램’을 내려받아 접속해 주세요.</li>
        <li>원격지원 중에는 상담원이 고객님의 PC 화면을 함께 봅니다. 개인정보가 담긴 창은 미리 닫아 주세요.</li>
        <li>전화 연결이 어려우면 <NuxtLink to="/support/inquiry">1:1문의</NuxtLink>로 증상을 남겨 주세요.</li>
      </ul>
    </div>
  </SupportFrame>
</template>
<style scoped>
.remote-steps h2{font-size:18px;font-weight:700;padding-bottom:12px;border-bottom:2px solid var(--board-navy)}
.remote-steps ol{list-style:none;padding:0;margin:0}
.remote-steps li{display:grid;grid-template-columns:auto minmax(0,1fr);gap:16px;align-items:start;padding:20px 10px;border-bottom:1px solid var(--board-line)}
.remote-step-no{display:inline-grid;place-items:center;width:32px;height:32px;border-radius:50%;background:var(--board-navy);color:#fff;font-size:14px;font-weight:800}
.remote-steps h3{font-size:16px;font-weight:700;margin-bottom:4px!important}
.remote-steps p{font-size:14px;line-height:1.7;color:#475569}
.remote-phone{color:var(--board-blue);font-size:16px}
.remote-action{display:flex;justify-content:center;padding:32px 0 28px}
.remote-open{min-height:52px;padding:12px 32px;font-size:16px}
.remote-notes{display:grid;gap:6px;padding:16px 20px 16px 36px;background:var(--board-bg);border:1px solid var(--board-line);border-radius:8px;font-size:14px;line-height:1.7;color:#475569}
.remote-notes a{color:var(--board-blue);font-weight:700;text-decoration:underline;text-underline-offset:3px}
@media(max-width:640px){.remote-steps li{padding:16px 4px;gap:12px}.remote-open{width:100%}.remote-notes{padding:14px 14px 14px 30px}}
</style>
